import vuexKeys from "@mixins/includes/_vuexKeys";
import query from '@mixins/helpers/_query';

import {PAGINATION} from '@constants/common';

let baseTab = {
    inheritAttrs: false,
    mixins: [vuexKeys, query],
    props: {
        name: {
            type: String,
            required: true
        }
    },
    data: () => ({
        query: {
            sort: null,
            pagination: {
                currentPage: 1,
                itemsPerPage: PAGINATION.CHUNK,
                totalItems: 0
            }
        }
    }),
};

export default baseTab;
